<template>
  <div>
    <el-row>
      <h4>转换日期：{{ this.send_DAY }}</h4>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName" style="margin-top: 10px">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="所需数量"></el-table-column>
          <el-table-column prop="IW_PRODUCT_COUNT" label="库存数量"></el-table-column>
          <el-table-column prop="BUYED_COUNT" label="建议采买数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.BUYED_COUNT"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button @click="submitTransfer" style="margin-top: 20px; float: right">确认转换</el-button>
        <el-button @click="chengeProduct" style="margin-top: 20px; margin-right: 10px; float: right">指定采购</el-button>
      </el-col>
    </el-row>
    <el-dialog :title="infoTitle" center :visible.sync="infoFormVisible" width="600px">
      <el-table :data="infoData" stripe border>
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
        <el-table-column label="产品名称" prop="NAME"></el-table-column>
        <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="infoFormVisible = false">取 消</el-button>
        <el-button @click="goSetting">前往设置</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择订单信息" center :visible.sync="addFormVisible" width="600px">
      <el-form size="small" :model="addForm" ref="addForm" :rules="rules">
        <el-form-item label="供应商：" :label-width="formLableWidth" prop="customer" v-show="actionFlag == 1">
          <el-select filterable v-model="addForm.customer" placeholder="请选择供应商" clearable style="width: 80%">
            <el-option v-for="item in customers" :key="item.SUPPLIER_ID" :label="item.NAME" :value="item.SUPPLIER_ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitAdd('addForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { haveCKSFun } from 'api/shopOrderManage';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      actionFlag: 1,
      checkedArray: [],
      rules: {
        customer: [
          { required: true, message: '请选择供应商', trigger: 'blur' },
        ],
      },
      send_DAY: sessionStorage.getItem('transferDate'),
      customers: [],
      formLableWidth: '100px',
      infoFormVisible: false,
      transferFalg: 0,
      addForm: {},
      infoData: [],
      infoTitle: '',
      addFormVisible: false,
      formLabelWidth: '100px',
    };
  },
  created() {
    this.queryTable();
    this.querySupplier();
  },
  methods: {
    queryTable() {
      const params = {
        SERVICE_ID: '12002',
        OTYPE: 13,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        ORDER_ID: sessionStorage.getItem('produceId'),
        SEND_DAY: sessionStorage.getItem('transferDate'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.transferFalg = result[0].FLAG;
        if (result[0].FLAG == 1) {
          this.infoFormVisible = true;
          this.infoData = result[0].DATA;
          this.infoTitle = '以下产品未设置配料表，请设置配料后转换';
          this.$message.show({
            text: '转换失败',
            type: 'error',
          });
        } else if (result[0].FLAG == 2) {
          this.infoFormVisible = true;
          this.infoData = result[0].DATA;
          this.infoTitle = '以下原料未设置采购价，请设置后转换';
          this.$message.show({
            text: '转换失败',
            type: 'error',
          });
        } else {
          this.tableData = result[0];
        }
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // --------------------------------------------获取供应商信息列表
    querySupplier() {
      haveCKSFun()
        .then((result) => {
          this.customers = result[0].list;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 指定采购
    tableRowClassName({ row }) {
      if (row.SUGGEST == 0) {
        return 'success-row';
      }
      return '';
    },
    handleSelectionChange(val) {
      this.checkedArray = val;
      console.log(val);
    },
    chengeProduct() {
      this.actionFlag = 1;
      this.addForm = {
        SEND_DAY: sessionStorage.getItem('transferDate'),
      };
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (this.checkedArray.length !== 0) {
        const flag = this.checkedArray.find((item) => {
          if (!reg.test(item.BUYED_COUNT)) {
            return true;
          }
        });
        if (flag) {
          this.$message.show({ text: '请输入正数采买数量', type: 'warning' });
          return false;
        }
        this.addFormVisible = true;
        // this.queryCustomer()
        this.submitArr = [];
        this.submitArr = this.checkedArray.map((item) => ({
          PRODUCT_CODE: item.PRODUCT_CODE, PRODUCT_COUNT: item.BUYED_COUNT, CP_CODE: item.CP_CODE, PRODUCE_ORDER_DETAIL_ID: item.PRODUCE_ORDER_DETAIL_ID,
        }));
        // tmpArr.forEach((item, index) => {
        //     this.submitArr.push(item.PRODUCT_CODE)
        // })
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
      }
    },
    close() {
      this.addFormVisible = false;
    },
    submitAdd() {
      if (!this.addForm.customer) {
        this.$message.show({ text: '请选择供应商', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10013',
            OTYPE: 17,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            PRODUCE_ORDER_ID: sessionStorage.getItem('produceId'),
            SEND_DAY: sessionStorage.getItem('transferDate'),
            SALE_ORDER_DAY: sessionStorage.getItem('transferDate'),
            PRODUCT_ARRAY: this.submitArr,
          };
          if (this.actionFlag == 1) {
            params.SUPPLIER_ID = this.addForm.customer;
          }
          if (this.currentOrderFlag == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
          }
          http.post(params)
            .then(() => {
              this.addFormVisible = false;
              this.$message.show({ text: '移动成功', type: 'success' });
              this.queryTable();
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
            });
        } finally {
          // console.log("我执行完了")
          document.body.style.cursor = 'default';
        }
      }
    },
    submitTransfer() {
      const tempArr = this.tableData.filter((item) => item.BUYED_COUNT > 0);
      const submitArr = tempArr.map((item) => ({ PRODUCT_CODE: item.PRODUCT_CODE, PRODUCT_COUNT: item.BUYED_COUNT }));

      // const submitArr = this.tableData.map((item) => ({ PRODUCT_CODE: item.PRODUCT_CODE, PRODUCT_COUNT: item.BUYED_COUNT }));
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      const flag = submitArr.find((item) => {
        if (!reg.test(item.PRODUCT_COUNT)) {
          return true;
        }
      });
      if (flag) {
        this.$message.show({ text: '请输入正数采买数量', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '12002',
        OTYPE: 14,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        ORDER_ID: sessionStorage.getItem('produceId'),
        SEND_DAY: sessionStorage.getItem('transferDate'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_ARRAY: submitArr,
      };
      http.post(params).then(() => {
        this.$router.push({ name: 'produceDetail' });
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    goSetting() {
      if (this.transferFalg == 1) {
        this.$router.push({ name: 'productionSet' });
      } else if (this.transferFalg == 2) {
        this.$router.push({ name: 'supplierManage' });
      } else {
        return false;
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/productionProcessing/transferShop.vue